module.exports = __webpack_public_path__ + "img/js.0e4fdce8.png";